/*
 * Product page buy button.
 *
 * The form is a real product form and works with JavaScript off: it posts to
 * /cart/add and return_to carries the customer on to checkout. This upgrades
 * that to a fetch so a failure can be reported on the page instead of on a
 * Shopify error screen, and so the button can show that it is working.
 *
 * On any failure the customer is not left with nothing: the item is either in
 * the cart or it is not, and either way the form is re-enabled and the message
 * says what to do.
 */
(function () {
  'use strict';

  var SUPPORT = 'hello@mail.calmlyte.com';
  var FAILED =
    'Checkout could not be reached. Nothing has been charged. ' +
    'Try again in a moment, or email ' + SUPPORT + ' and we will take the order directly.';
  var SOLD_OUT = 'That item is no longer available.';

  function checkoutUrl() {
    /* routes.cart_url is '/cart' on a single-locale store and '/en-gb/cart' on
       a localised one. Deriving checkout from it keeps the locale prefix, which
       a hard-coded '/checkout' would drop. */
    var cart = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return cart.replace(/\/$/, '') + '/checkout';
  }

  function submit(form, button) {
    var body = new FormData(form);
    /* return_to is for the no-JS path. Sending it to /cart/add.js makes the
       response a redirect rather than the JSON this handler expects. */
    body.delete('return_to');

    button.disabled = true;
    button.dataset.busy = 'true';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          /* 422 is Shopify's "cannot add this line": sold out, or a quantity
             beyond stock. Its own description is more specific than anything
             this file could write, so it is preferred when present. */
          var message = result.status === 422
            ? (result.data && result.data.description) || SOLD_OUT
            : FAILED;
          throw new Error(message);
        }

        if (form.querySelector('[name="return_to"]') || button.dataset.directCheckout === 'true') {
          window.location.href = checkoutUrl();
          return;
        }

        button.disabled = false;
        delete button.dataset.busy;
        if (window.calmlyteToast) window.calmlyteToast('Added to your cart.', 'ok');
        document.dispatchEvent(new CustomEvent('calmlyte:cart:changed'));
      })
      .catch(function (err) {
        button.disabled = false;
        delete button.dataset.busy;
        if (window.calmlyteToast) window.calmlyteToast(err.message || FAILED, 'error');
        else if (window.console) console.warn('[calmlyte] add to cart failed:', err);
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    var button = form.querySelector('button[type="submit"], button[name="add"]');
    if (!button || button.disabled) return;

    event.preventDefault();
    submit(form, button);
  });
})();
